import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import Button from "@/components/Atoms/Button";
import SVGSprite from "@/components/Atoms/SVGSprite";
import Image from "@/components/Atoms/Image";

import Typography from "@/foundation/Typography/V2";

export const MenuLink = styled(Typography)``;

export const Accordion = styled(FlexDiv)`
  position: relative;
  padding-left: 30px;
  padding-right: 55px;
  cursor: pointer;
`;

export const Arrow = styled(FlexDiv)`
  height: 28px;
  width: 28px;
  padding: 5px;
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
`;

export const CloseBtn = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AccordionWrap = styled(FlexDiv)`
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const DropdownWrap = styled(FlexDiv)`
  max-height: ${({ expandable }) => (expandable ? "1000px" : "0px")};
  overflow: hidden;
  transition: all 0.2s ease-in-out;
  ${MenuLink} {
    &:first-child {
      margin-top: 30px;
    }
    transition: all 0.2s ease-in-out;
    padding: 7px 30px;
    &:hover {
      background-color: ${({ theme }) => theme.colors.white};
    }
  }
`;

export const ArrowIcon = styled(SVGSprite)`
  transition: all 0.2s ease-in-out;
  ${({ ismenuopen }) =>
    ismenuopen === "true" &&
    `
  transform: rotate(90deg);
  `};
`;

export const AccordionText = styled(Typography)`
  transition: all 0.2s ease-in-out;
  @media only screen and (max-width: 374px) {
    font-size: 18px;
  }
`;

export const ButtonWrap = styled(FlexDiv)`
  button {
    border-width: 1px;
    font-family: var(--font-700);
    font-size: 14px;
  }
`;

export const ImageDownload = styled(Image)``;

export const DownloadSection = styled(FlexDiv)`
  @media only screen and (max-width: 399px) {
    ${ImageDownload} {
      max-width: 115px;
    }
  }
  @media only screen and (max-width: 374px) {
    ${ImageDownload} {
      max-width: 100px;
    }
  }
`;
